import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export default ({ component: C, props: cProps, service: service, ...rest }) => (
  <Route {...rest} render={props => (
  	/*
  	if (cProps.isAuthenticated && service != 'default') {
  		cProps.approvedServices.indexOf(service) > -1 ? <C {...props} {...cProps} /> : <Redirect to={`/notfound?redirect=${props.location.pathname}${props.location.search}`} />
  	} else if (cProps.isAuthenticated && service == 'default') {
  		return (<C {...props} {...cProps} />);
  	}
  	*/
  	// If user authenticated and accessing default service page
  	(cProps.isAuthenticated && service === 'default') 
  	// Allow access
  	? <C {...props} {...cProps} /> 
  	// If user authenticated and accessing custom service page they have permissions to
			: (cProps.isAuthenticated && (cProps.approvedServices.indexOf('Administrators') > -1 || cProps.approvedServices.indexOf(service) > -1)) 
  		// Allow access
  		? <C {...props} {...cProps} /> 
  		// If user authenticated and accessing custom service page they do not have permissions to
  		: (cProps.isAuthenticated && cProps.approvedServices.indexOf(service) === -1) 
  			// Redirect to NOT FOUND
  			? <Redirect to={`/notfound?redirect=${props.location.pathname}${props.location.search}`} /> 
  			// Otherwise user is unauthenticated --> redirect to LOGIN
  			: <Redirect to={`/login?redirect=${props.location.pathname}${props.location.search}`} />
  	/*
    cProps.isAuthenticated && service != 'default' && cProps.approvedServices.indexOf(service) > -1 
      ? <C {...props} {...cProps} />
      : <Redirect to={`/login?redirect=${props.location.pathname}${props.location.search}`} />
     */
  )}/>
);


// WEBPACK FOOTER //
// ./src/components/AuthenticatedRoute.js